import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-left text-2xl my-[3%]" }
const _hoisted_2 = { class: "font-medium" }

import OffersTable from './OffersTable.vue'
    
    import useOfferStore from '@/utils/useOfferStore'
    import { SelectedOffer } from '@/model/types'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'OffersSection',
  props: {
        offers: Array,
        selectOffer: Function,
        confirmDeleteSingleOffer: Function,
        downloadPdf: Function,
        addOfferLink: String,
    },
  setup(__props) {

    const { selectOffer, confirmDeleteSingleOffer, downloadPdf } = useOfferStore()

    const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('offers.title')), 1)
    ]),
    _createVNode(OffersTable, {
      offers: __props.offers as SelectedOffer[],
      selectOfferMethod: _unref(selectOffer),
      deleteMethod: _unref(confirmDeleteSingleOffer),
      pdfMethod: _unref(downloadPdf)
    }, null, 8, ["offers", "selectOfferMethod", "deleteMethod", "pdfMethod"])
  ]))
}
}

})